// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/electric-aeroplane-training.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/electric-aeroplane-training/electric-aeroplane-training.js';

mount([g0]);
